import {
  getDecimalSeparator,
  parseLocaleNumber,
} from '@/utils/localeNumberParser';

import type { InputNumberProps } from 'antd';

/** Locale-aware decimal separator and parser for Ant Design InputNumber. */
export function getLocaleInputNumberProps(
  language: string,
): Pick<InputNumberProps, 'decimalSeparator' | 'parser'> {
  return {
    decimalSeparator: getDecimalSeparator(language),
    parser: (value) => parseLocaleNumber(value),
  };
}
